import React from 'react';
import { Field } from 'redux-form'

class SRARadioField extends React.Component {

    render () {
        return (
            <div>
                <Field
                    name={`question${this.props.questionID}${this.props._key}`}
                    component='input'
                    type='radio'
                    id={`question${this.props.questionID}${this.props._key}`}
                    value={this.props.value}
                    checked={this.props.checked}
                    onClick={(e) => {
                        this.props.selectAnswer(
                            this.props.questionID,
                            e.target.value,
                            this.props.nextQuestion)
                    }}
                />
                {this.props.value}
                <span className="checkmark">
                </span>

            </div>
        )
    }

}


export default SRARadioField


// WEBPACK FOOTER //
// ./src/components/sra/components/SRARadioField.js